import { createSelector } from 'reselect'

const getPaymentReminderTags = (state) => state.paymentReminderTags.data

export const getPaymentReminderTagsSelector = createSelector(
  [getPaymentReminderTags],
  (state) => state && state.map(({ placeholder, tag }) => ({ name: tag, placeholder })),
)
